"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserEnroll = exports.EnterDetail = exports.getAuthInfos = exports.generalValidate = exports.getBlackUserlist = exports.getLuyanBaseInfo = exports.getlkAccessInfo = void 0;
/**
 * 浪客路演数据
 */
var config = require("../../../config/web");
var hex_md5 = require('../md5');
var cookie_1 = __importDefault(require("../cookie"));
/** 获取浪客接口通用参数 */
function getLkJsonParam() {
    var params = {
        'device_id': "35dkmnjhbgtyhjko",
        'version': '1.0.0',
        'plat': 'Web',
        'product': 'EastMoney',
        'network': 'Wifi',
        'model': 'pc',
        'osversion': '1.0'
    };
    // 用户登陆情况下
    var uid = cookie_1.default.get('uidal');
    if (uid) {
        uid = uid.substring(0, 16);
        params.device_id = hex_md5(uid);
    }
    else {
        if (cookie_1.default.get('langke_did')) {
            params.device_id = hex_md5(cookie_1.default.get('langke_did'));
        }
        else {
            // let did = mathrandomstr(20);
            var did = String((Math.random() + 1) * Math.pow(10, 20 - 1));
            cookie_1.default.set('langke_did', did, 10000);
            params.device_id = hex_md5(did);
        }
    }
    return params;
}
/**
 * 获取浪客通行证相关信息
 * */
function getlkAccessInfo() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, $.ajax({
                    url: '/api/getlkinfos',
                    type: 'GET',
                    dataType: 'json'
                })];
        });
    });
}
exports.getlkAccessInfo = getlkAccessInfo;
/**
 * 浪客路演基础信息
 * @param luyan_id
 */
function getLuyanBaseInfo(luyan_id) {
    return __awaiter(this, void 0, Promise, function () {
        var back, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, $.ajax({
                            url: "".concat(config.getWebPath('lk'), "api/Roadshow/Detail?callback=?"),
                            type: 'GET',
                            dataType: 'jsonp',
                            data: __assign(__assign({ channel_id: luyan_id }, getLkJsonParam()), { ctoken: cookie_1.default.get('lkCToken') || "", utoken: cookie_1.default.get('lkUToken') || "" })
                        })];
                case 1:
                    back = _a.sent();
                    if (back === null || back === void 0 ? void 0 : back.data) {
                        return [2 /*return*/, back.data];
                    }
                    return [2 /*return*/, null];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.getLuyanBaseInfo = getLuyanBaseInfo;
/**
 * 获取黑名单
 * no_entering是否被禁入
 * no_speaking是否被禁言
 */
function getBlackUserlist(roomid, uid) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var json, blackUser, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, $.ajax({
                            url: "".concat(config.getWebPath('lk'), "api/Room/BlacklistUser?callback=?"),
                            type: 'GET',
                            dataType: 'jsonp',
                            data: __assign(__assign({ channel_id: roomid }, getLkJsonParam()), { ctoken: cookie_1.default.get('lkCToken') || "", utoken: cookie_1.default.get('lkUToken') || "" })
                        })];
                case 1:
                    json = _b.sent();
                    blackUser = (_a = json === null || json === void 0 ? void 0 : json.data) === null || _a === void 0 ? void 0 : _a.map(function (value) {
                        var no_entering = value.emuid == uid && !!value.no_entering;
                        var no_speaking = value.emuid == uid && !!value.no_speaking;
                        return { no_entering: no_entering, no_speaking: no_speaking };
                    });
                    return [2 /*return*/, blackUser === null || blackUser === void 0 ? void 0 : blackUser[0]];
                case 2:
                    error_2 = _b.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.getBlackUserlist = getBlackUserlist;
/**
 * 权限验证
 * @param roomid
 * @param dbg_ticket
 * @returns
 */
function generalValidate(opt) {
    return __awaiter(this, void 0, void 0, function () {
        var json, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, $.ajax({
                            url: "".concat(config.getWebPath('lk'), "api/PermissionAction/GeneralValidate?callback=?"),
                            type: 'GET',
                            dataType: 'jsonp',
                            data: __assign(__assign({ channel_id: opt.channel_id, password: "", view_type: 4, dbg_ticket: opt.dbg_ticket }, getLkJsonParam()), { ctoken: cookie_1.default.get('lkCToken') || "", utoken: cookie_1.default.get('lkUToken') || "" })
                        })];
                case 1:
                    json = _a.sent();
                    return [2 /*return*/, json];
                case 2:
                    error_3 = _a.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.generalValidate = generalValidate;
/**
 * 验证信息
 * @param dbg_ticket
 * @returns
 */
function getAuthInfos(dbg_ticket) {
    return __awaiter(this, void 0, void 0, function () {
        var obj;
        return __generator(this, function (_a) {
            obj = {
                channel_id: window.urlid,
                password: "",
                view_type: 4,
                dbg_ticket: dbg_ticket
            };
            return [2 /*return*/, generalValidate(obj)];
        });
    });
}
exports.getAuthInfos = getAuthInfos;
/*
* 进入房间统计:认证相关
*/
function EnterDetail(authinfo, debug_session_id) {
    var _a, _b, _c, _d, _e;
    return __awaiter(this, void 0, void 0, function () {
        var access_token, dbg_access_token, session_id, json, error_4;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 2, , 3]);
                    access_token = ((_a = authinfo === null || authinfo === void 0 ? void 0 : authinfo.data) === null || _a === void 0 ? void 0 : _a.access_token) || "";
                    dbg_access_token = ((_b = authinfo === null || authinfo === void 0 ? void 0 : authinfo.data) === null || _b === void 0 ? void 0 : _b.dbg_access_token) || "";
                    session_id = ((_e = (_d = (_c = authinfo === null || authinfo === void 0 ? void 0 : authinfo.data) === null || _c === void 0 ? void 0 : _c.debug_config) === null || _d === void 0 ? void 0 : _d.current_session) === null || _e === void 0 ? void 0 : _e.session_id) || "";
                    return [4 /*yield*/, $.ajax({
                            url: "".concat(config.getWebPath('lk'), "api/RoomAction/Enter?callback=?"),
                            type: 'GET',
                            dataType: 'jsonp',
                            data: __assign(__assign({ channel_id: window.urlid, access_token: access_token, dbg_access_token: dbg_access_token, debug_session_id: session_id || debug_session_id }, getLkJsonParam()), { ctoken: cookie_1.default.get('lkCToken') || "", utoken: cookie_1.default.get('lkUToken') || "" })
                        })
                        //删除5002
                    ];
                case 1:
                    json = _f.sent();
                    //删除5002
                    if ((json === null || json === void 0 ? void 0 : json.result) == 5002) {
                        self.location.href = "/404.html";
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/, json || {}];
                case 2:
                    error_4 = _f.sent();
                    return [2 /*return*/, {}];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.EnterDetail = EnterDetail;
/**
 * 报名
 * @param authinfo
 * @param debug_session_id
 * @returns
 */
function UserEnroll() {
    return __awaiter(this, void 0, void 0, function () {
        var error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, $.ajax({
                            url: "".concat(config.getWebPath('lk'), "api/PermissionAction/UserEnroll"),
                            type: 'GET',
                            dataType: 'jsonp',
                            data: __assign(__assign({ channel_id: window.urlid }, getLkJsonParam()), { ctoken: cookie_1.default.get('lkCToken') || "", utoken: cookie_1.default.get('lkUToken') || "" }),
                            jsonpCallback: 'data' + Math.floor(Math.random() * 10000000 + 1)
                        })];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    error_5 = _a.sent();
                    return [2 /*return*/, {}];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.UserEnroll = UserEnroll;
//# sourceMappingURL=data:application/json;base64,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